class VgApiClient {

	ajaxEndpoint;
	#action;
	#params;

	constructor(country = 'es', lang = 'es') {
		this.ajaxEndpoint = `/${country}-${lang}/wp-content/plugins/vivagym-joining/includes/ajax-light.php`;
		this.#action = {};
		this.#params = {};
		this.signal = null;
	}

	set ajaxEndpoint(newEndpoint) {
		this.ajaxEndpoint = newEndpoint;
	}

	get ajaxEndpoint() {
		return this.ajaxEndpoint;
	}

	set action(newAction) {
		this.#action = newAction;
	}

	get action() {
		return this.#action;
	}

	set params(newParams) {
		this.#params = newParams;
	}

	get params() {
		return this.#params;
	}

	async handleRequest() {
		const startTime = performance.now(); // TODO: debug purposes, delete after testing
		const action = this.#action;
		const params = this.#params;
		try {
			const response = await fetch(this.ajaxEndpoint, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					action,
					params,
				}),
				signal: this.signal
			});

			if (!response.ok) {
				throw new Error(`HTTP error, Status: ${response.status}`);
			}

			const data = await response.json();

			// TODO: debug purposes, delete after testing
			const endTime = performance.now();
			const elapsedTime = endTime - startTime;
			console.log(`AJAX Total time (${action}): ${elapsedTime.toFixed(2)} ms`);

			return data;

		} catch (error) {
			if (error.name === 'AbortError') {
				console.error('Fetch aborted');
			} else {
				console.error("Error in AJAX request:", error);
			}
			return null;
		}
	}

	async setTablet() {
		this.action = "set_tablet";
		this.params = {};
		return this.handleRequest();
	}

	async processJoiningSsoLogin(user, country) {
		this.action = "process_joining_sso_login";
		this.params = { user: user, country: country };
		return this.handleRequest();
	}

	async processJoiningStepSelectGym(gymData, extendedAttributes, country) {
		this.action = "process_joining_step_select_gym";
		this.params = { gym_data: gymData, extended_attributes: extendedAttributes, country: country };
		return this.handleRequest();
	}

	async createGuestUser(country) {
		this.action = "process_joining_create_guest_user";
		this.params = { country: country };
		return this.handleRequest();
	}

	async processJoiningStepSelectQuoteByUrlParams(gymId, gymData, country) {
		this.action = "process_joining_step_select_quote_by_url_params";
		this.params = { gym_id: gymId, gym_data: gymData, country: country };
		return this.handleRequest();
	}

	async processJoiningStepUserData(gymId, user, formData, extendedAttributes, gymCountry, country, is_day_pass_selected) {
		this.action = "process_joining_step_user_data_no_short";
		this.params = { gym_id: gymId, user: user, form_data: formData, extended_attributes: extendedAttributes, gym_country: gymCountry, country: country, is_day_pass_selected: is_day_pass_selected };
		return this.handleRequest();
	}

	async validateUserSSOToken(externalId, ssoToken, country) {
		this.action = "validate_user_sso_token";
		this.params = { external_id: externalId, sso_token: ssoToken, country: country };
		return this.handleRequest();
	}

	async getUserExternalId(userToken, country) {
		this.action = "get_user_external_id";
		this.params = { user_token: userToken, country: country };
		return this.handleRequest();
	}

	async checkIfExist(email, country) {
		if (!/^[A-Za-z0-9.!#$%&'*+=?^_`{|}~-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*$/.test(email)) {
			return {error: 'Empty email or invalid'};
		}
		this.action = "check_if_exists";
		this.params = { email: email, locale: country };
		return this.handleRequest();
	}

	async getGymById(gymId) {
		this.action = "get_gym";
		this.params = { gym_id: gymId };
		return this.handleRequest();
	}

	async getGymByIdFromCPT(gymId) {
		this.action = "get_gym_from_cpt";
		this.params = { gym_id: gymId };
		return this.handleRequest();
	}

	async getGymParkingOptions(gymId, country) {
		this.action = "get_gym_parking_options";
		this.params = { gym_id: gymId, country: country };
		return this.handleRequest();
	}

	async getGymBAFOptions(gymId) {
		this.action = "get_gym_baf_options";
		this.params = { gym_id: gymId };
		return this.handleRequest();
	}

	async getGymPricePeriod(gymId) {
		this.action = "get_gym_price_period";
		this.params = { gym_id: gymId};
		return this.handleRequest();
	}

	async getGymMarketingOptions(gymId) {
		this.action = "get_gym_marketing_options";
		this.params = { gym_id: gymId };
		return this.handleRequest();
	}

	async getGymPreselectedInsurance(gymId) {
		this.action = "get_gym_preselected_insurance";
		this.params = { gym_id: gymId };
		return this.handleRequest();
	}

	async getGymsByRegion(country, locale) {
		this.action = "get_gyms_by_region";
		this.params = { country: country, locale: locale };
		return this.handleRequest();
	}

	async getGymsByRegionFromDatabase(country) {
		this.action = "get_gyms_by_region_from_database";
		this.params = { country: country };
		return this.handleRequest();
	}

	async getSubscriptions(gymId, country) {
		this.action = "get_subscriptions";
		this.params = { center_id: gymId, country: country };
		return this.handleRequest();
	}

	async getEncodeString(country, string_to_encode) {
		this.action = "get_encode_string";
		this.params = { country: country, string_to_encode: string_to_encode };
		return this.handleRequest();
	}

	async getSubscriptionsGymsByRegion(gymId, country, lang) {
		if (!gymId || !country || !lang) {
			return;
		}

		this.action = "get_subscriptions_gyms_by_region";
		this.params = { center_id: gymId, country: country, lang: lang };
		return this.handleRequest();
	}

	async getSubscriptionsGymsByCluster(gymId, country, lang) {
		this.action = "get_subscriptions_gyms_by_cluster";
		this.params = { center_id: gymId, country: country, lang: lang };
		return this.handleRequest();
	}

	async getSubscriptionsGymsByPrice(gymId, country, lang) {
		this.action = "get_subscriptions_gyms_by_price";
		this.params = { center_id: gymId, country: country, lang: lang };
		return this.handleRequest();
	}

	async adjustBringAFriend(clipcard_id, gym_id, sub_id, country, token) {
		this.action = "adjust_clipcard_bring_a_friend";
		this.params = { clipcard_id: clipcard_id, gym_id: gym_id, sub_id:sub_id, country:country, token: token };
		return this.handleRequest();
	}

	async getSubscriptionsGymsBy(gymId) {
		this.action = "get_subscriptions_gyms_by";
		this.params = { center_id: gymId };
		return this.handleRequest();
	}

	async getClipcardDetails(country, gym_id, clipcard_id, sub_id) {
		this.action = "get_clip_details";
		this.params = { country: country, gym_id: gym_id, clipcard_id: clipcard_id, sub_id: sub_id };

		return this.handleRequest();
	}

	async cleanUserLead(country) {
		this.action = "clean_user_lead";
		this.params = { country: country };
		return this.handleRequest();
	}

	async getGymSurvey(gymId, country) {
		if (!gymId || !country) {
			return;
		}
		this.action = "get_survey_by_gym_id";
		this.params = { gym_id: gymId, country: country };
		return this.handleRequest();
	}

	async getGymActivities(filters, country = 'es', language = 'es') {
		if (!filters) {
			return;
		}

		this.action = "activities_filter";
		this.params = { filters: filters, country: country, language: language };
		return this.handleRequest();
	}

	async updateUserMultipleExtendedAttribute(extendedAttributes, country) {
		this.action = "update_user_multiple_extended_attribute";
		this.params = { extended_attributes: extendedAttributes, country: country };
		return this.handleRequest();
	}

	async checkPersonNationalId(idCardNumber, locale) {
		this.action = "validate_person_national_id";
		this.params = { national_id: idCardNumber.toUpperCase(), locale: locale };
		return this.handleRequest();
	}

	async checkPersonPassport(passportNumber, country, locale) {
		this.action = "validate_person_passport";
		this.params = { passport_number: passportNumber.toUpperCase(), passport_country: country, locale: locale };
		return this.handleRequest();
	}

	async checkPostalCode(zipCode, country) {
		this.action = "check_zipcode";
		this.params = { zipcode: zipCode, country: country };
		return this.handleRequest();
	}

	async getBasketExternalId(shoppingBasketId) {
		if ( ! shoppingBasketId ) {
			return false;
		}

		this.action = "get_shopping_basket";
		this.params = { shopping_basket_id: shoppingBasketId };
		return this.handleRequest();
	}

	async getCreditCardAllowed(country) {
		this.action = "credit_card_allowed";
		this.params = { country: country };
		return this.handleRequest();
	}

	async checkIfIsAnonymous(externalId) {
		this.action = "check_if_is_anonymous";
		this.params = { external_id: externalId };
		return this.handleRequest();
	}

	async getPaymentAgreement(country) {
		this.action = "get_payment_agreement";
		this.params = { country: country };
		return this.handleRequest();
	}

	async setPaymentAgreementSepa(sepaData, country) {
		this.action = "set_payment_agreement_sepa";
		this.params = { sepa_data: sepaData, country: country };
		return this.handleRequest();
	}

	async payShoppingBasket(basketParams, country) {
		this.action = "pay_shopping_basket";
		this.params = { basket_params: basketParams, country: country };
		return this.handleRequest();
	}

	async validatePromoCode(gymId, promoCode, country, skipAuth = false) {
		this.action = "validate_promo_code";
		this.params = { gym_id: gymId, promo_code: promoCode, country: country, skip_auth: skipAuth };
		return this.handleRequest();
	}

	async validateIban(iban, country) {
		this.action = "validate_iban";
		if ( null == iban || null == country ) {
			return false;
		}
		const cleanIban = decodeURIComponent(iban)
			.replace(/[^A-Za-z0-9]/g, '')
			.toUpperCase();

		this.params = { iban: cleanIban, country: country };
		return this.handleRequest();
	}

	async getAdyenSession(adyenSessionParams) {
		this.action = "get_adyen_session_no_short";
		this.params = { adyen_params: adyenSessionParams };
		return this.handleRequest();
	}

	async createPaymentIntent(paymentData, operation, country) {
		this.action = "create_payment_intent";
		this.params = { payment_data: paymentData, operation: operation, country: country };
		return this.handleRequest();
	}

	async getPaymentStatus(orderId, country) {
		this.action = "get_payment_status";
		this.params = { order_id: orderId, country: country };
		return this.handleRequest();
	}

	async validateRecaptcha(token) {
		this.action = "validate_recaptcha";
		this.params = { token: token };
		return this.handleRequest();
	}

	async processLead(formData, country) {
		this.action = "process_lead_no_short";
		this.params = { form_data: formData, country: country };
		return this.handleRequest();
	}

	async processContactForm(formData, country) {
		this.action = "process_contact_form_no_short";
		this.params = { form_data: formData, country: country };
		return this.handleRequest();
	}

	async processTrainerForm(formData, country) {
		this.action = "process_trainer_form_no_short";
		this.params = { form_data: formData, country: country };
		return this.handleRequest();
	}

	async processCorporateForm(gymId, user, formData, country, bring_a_friend) {
		this.action = "process_corporate_form_no_short";
		this.params = { gym_id: gymId, user: user, form_data: formData, country: country, bring_a_friend: bring_a_friend };
		return this.handleRequest();
	}

	async processTBCForm(formData, country) {
		//TODO: revise final implementation.
		this.action = "process_tbc_form_no_short";
		this.params = { form_data: formData, country: country };
		return this.handleRequest();
	}

	async getRandomTestimony() {
		this.action = "get_random_testimony";
		this.params = {};
		return this.handleRequest();
	}

	async getAllTestimonies() {
		this.action = "get_all_testimonies";
		this.params = {};
		return this.handleRequest();
	}

	async getGymUrl(store_id) {
		this.action = "get_gym_url_no_short";
		this.params = { store_id: store_id };
		return this.handleRequest();
	}

	async getTrainersByGym(gymId, country) {
		this.action = "get_trainers_by_gym";
		this.params = { gym_id: gymId, country: country };
		return this.handleRequest();
	}

	async getFormNonce(form_name) {
		this.action = "get_form_nonce";
		this.params = { form_name: form_name };
		return this.handleRequest();
	}

	async validateNonce(nonce, form_name) {
		this.action = "check_form_nonce";
		this.params = { nonce: nonce, form_name: form_name };
		return this.handleRequest();
	}

	async getAdyenWaitingTime() {
		this.action = "get_adyen_waiting_time";
		this.params = {};
		return this.handleRequest();
	}

	async logUserAction(payload) {
		this.action = "log_user_action";
		this.params = {payload : payload}
		return this.handleRequest();
	}

	async submitSurveyAnswers(surveyData, country, clientName = null, clientEmail = null, gymId = null, clientToken = null) {
		this.action = "submit_survey_answers";
		this.params = { survey_data: surveyData, country: country };
		if (clientName) {
			this.params.client_name = clientName;
		}
		if (clientEmail) {
			this.params.client_email = clientEmail;
		}
		if (gymId) {
			this.params.gym_id = gymId;
		}
		if (clientToken) {
			this.params.client_token = clientToken;
		}
		return this.handleRequest();
	}

	async get_country_data(params) {
		this.action = "get_country_data_no_short";
		this.params = { country : params.country };
		return this.handleRequest();
	}
}
